import { graphql } from "~/gql";

export const DATA_IMPORT_COMPLETED_SUBSCRIPTION = graphql(/* GraphQL */ `
  subscription FileDataImportCompleted {
    fileDataImportCompleted {
      entityType
      created
      updated
      deleted
      importErrors
      totalErrors
    }
  }
`);

export const DATA_IMPORT_PROGRESS = graphql(/* GraphQL */ `
  subscription FileDataImportProgress {
    fileDataImportProgress {
      percentage
      hasError
    }
  }
`);
